<template>
    <div class="container">
        <PageTitle class="mt-4" title="Solicitações de Saque Vendedor" />
        <hr class="linha-amarela mb-4" />
        <div class="mb-5">
            <FilterBar />
        </div>
        <div class="mb-3">
            <h5>Total de solicitação {{totalPages}}</h5>
        </div>
        <b-table
            striped
            hover
            show-empty
            class="text-center"
            empty-text="Sem registros encontrados"
            :fields="table.headers"
            :items="table.records"
            :busy="loading"
            :per-page="perPage"
            :current-page="currentPage"
        >
            <template #cell(created_at)="data">
                {{formatDate(data.item.created_at)}}
            </template>
            
            <template #cell(value)="data">
                R$ {{formatMoneyUn(data.item.value/100)}}
            </template>
            
            <template #cell(status)="data">

                <v-select
                    v-if="statusActive == data.index"
                    v-model="data.item.status"
                    :options="optionStatus"
                    :loading="loading"
                >
                </v-select>
                
                <span v-else>
                    {{statusEnum(data.item.status)}}
                </span>
    

            </template>

            <template #cell(name)="data">
                {{data.item.clerk[0].name}}
            </template>

            <template #cell(action)="data">
                <b-col style="width: 150px" class="pr-0">

                    <b-btn
                        :disabled="data.item.status == CoinStatus.CANCELADO || data.item.status == CoinStatus.APROVADO"
                        @click="showModal(data.item)"
                        variant="primary"
                        :title="data.item.status == CoinStatus.CANCELADO || data.item.status == CoinStatus.APROVADO ? 'Status não pode ser alterado' : 'Alterar status'"
                        class="mb-2"
                        size="sm"
                    >
                        <i class="fa fa-pen"></i>
                    </b-btn>
                </b-col>
            </template>
        </b-table>

        <div class="d-flex justify-content-center">
            <b-pagination
                v-model="currentPage"
                :total-rows="totalPages"
                :per-page="perPage"
            ></b-pagination>
        </div>

        <b-modal
            title="Alterar status"
            size="md"
            header-bg-variant="orange"
            header-text-variant="light"
            centered
            hide-footer
            no-close-on-backdrop
            id="status-modal"
        >
            <modal-status
                :data="dataUser"
                @update-page="getAll()"
            ></modal-status>
        </b-modal>

    </div>
</template>
<script>
import { mapState } from "vuex";
import CoinStatus from '../../../enums/CoinStatus';
import ModalStatus from './ModalStatus.vue';
import makeToast from 'Mixins/makeToast';
import FilterBar from './FilterBar.vue';
import PageTitle from '@/components/PageTitle.vue';
export default {
    mixins: [makeToast],
    components: {ModalStatus, FilterBar, PageTitle},
    data() {
        return {
            CoinStatus,
            currentPage: 1,
            perPage: 15,
            totalPages: '',
            statusActive: null,
            statusEdit: null,
            dataUser: [],
            optionStatus: [
                'Aguardando Aprovação', 
                'Aprovar Pedido', 
            ],
            table: {
                headers: [
                    {
                        key: 'id',
                        thClass: 'd-none',
                        tdClass: 'd-none',
                    },
                    {
                        key: 'created_at',
                        label: 'Data',
                        sortable: false,
                    },
                    {
                        key: 'name',
                        label: 'Vendedor',
                        sortable: false,
                    },
                    {
                        key: 'value',
                        label: 'Valor',
                        sortable: false,
                    },
                    {
                        key: 'status',
                        label: 'Status',
                        sortable: false,
                    },
                    {
                        key: 'action',
                        label: 'Ações',
                        sortable: false,
                    },
                ],
                records: [],
            },
            loading: false,
        }
    },
     watch: {
        'currentPage': function () {
        this.getAll();
    },
  },
    computed: {
    ...mapState(['token', 'dadosUsuario'])
},

    mounted() {
        this.getAll();
    },

    methods: {
        getAll() {
            this.$store.dispatch('startLoader');
            this.$store.dispatch('balconista/getAllLog', this.currentPage)
            .then((resp) => {
                this.table.records = [];
                this.table.records = resp.data.data.data || resp.data.data;
                this.currentPage = resp.data.data.current_page;
                this.totalPages = resp.data.data.total;
            })
            .catch(() => {
                this.makeToast('Oopss', 'Houve um erro ao trazer os logs!', 'danger')
            })
            .finally(() => {
                this.$store.dispatch('endLoader')
            });
        },

        showModal(data) {
            this.dataUser = data;
            this.$bvModal.show('status-modal');
        },

        statusEnum(status) {
            if (status == this.CoinStatus.APROVADO) {
                return "Aprovado!";
            }
            if (status == this.CoinStatus.SOLICITADO) {
                return "Aguardando aprovação";
            }
            if (status == this.CoinStatus.CANCELADO) {
                return "Cancelado";
            }
        },

        formatMoneyUn(value) {
        var money = parseFloat(value);
        return money.toLocaleString('pt-br', {minimumFractionDigits: 2});
    },

        formatDate(date) {
            return new Date(date).toLocaleDateString('pt-BR', { timeZone: 'UTC' });
        },
    }
}
</script>
<style scoped>

</style>